<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: null}, {'display': 'What\'s New', commands: null}]"></app-logo-area>
<main>
  <app-headline-section [title]="'What\'s New'">
    <button type="button" class="btn cl-color-sea" (click)="dismiss()"><span>To my work</span></button>
  </app-headline-section>
  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          @if (loading) {
            <div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div>
          } @else if (entries.length === 0) {
            <p class="alert cl-alert-info" role="alert">No release notes are available yet.</p>
          } @else {
            <ol class="changelog">
              @for (entry of entries; track entry.tag) {
                <li class="changelog-entry">
                  <div class="changelog-meta">
                    <span class="changelog-date cl-font-monospace"><app-date [value]="entry.published_at" /></span>
                    @if (entry.html_url) {
                      <a class="changelog-tag" [href]="entry.html_url" target="_blank" rel="noopener">{{ entry.tag }}</a>
                    } @else {
                      <span class="changelog-tag">{{ entry.tag }}</span>
                    }
                  </div>
                  @if (entry.headline) {
                    <p class="changelog-headline">{{ entry.headline }}</p>
                  }
                  @if (entry.highlights.length > 0) {
                    <ul>
                      @for (highlight of entry.highlights; track highlight) {
                        <li>{{ highlight }}</li>
                      }
                    </ul>
                  }
                </li>
              }
            </ol>
          }
        </div>
      </div>
    </div>
  </section>
</main>